import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MobileNumberInputComponent } from '@app/shared/components/mobile-number-input/mobile-number-input.component';
import { TextInputComponent } from '@app/shared/components/text-input/text-input.component';
import { customEmailValidator } from '@app/shared/validators/email-validator';

export interface UserRegistrationData {
  name: string;
  email: string;
  mobile: number;
  companyName: string;
  designation?: string;
}

@Component({
  selector: 'app-user-registration',
  imports: [
    MatDialogModule,
    CommonModule,
    MatInputModule,
    MatIconModule,
    TextInputComponent,
    ReactiveFormsModule,
    MobileNumberInputComponent,
  ],
  templateUrl: './user-registration.component.html',
  styleUrl: './user-registration.component.scss',
})
export class UserRegistrationComponent {
  userForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<UserRegistrationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {
    this.userForm = this.fb.group({
      name: [null, [Validators.required]],
      email: [null, [Validators.required, customEmailValidator()]],
      mobileNumber: [null, [Validators.required]],
      company: [null, [Validators.required]],

      designation: null,
    });

    if (data && data.email) {
      this.userForm.get('email')?.setValue(data.email);
    }
  }

  onClose() {
    this.dialogRef.close();
  }

  onSubmit() {
    let formData: { [key: string]: string | number } = this.userForm.value;

    const exchangeFieldNames: { [key: string]: string } = {
      mobileNumber: 'mobile',
      company: 'companyName',
      designation: 'positionName',
    };

    const mutationData: UserRegistrationData = Object.keys(formData).reduce(
      (accumulator: UserRegistrationData, currentValue) => {
        if (formData[currentValue]) {
          if (exchangeFieldNames[currentValue]) {
            (accumulator as any)[exchangeFieldNames[currentValue]] = formData[currentValue];
          } else {
            (accumulator as any)[currentValue] =
              typeof formData[currentValue] === 'string' ? formData[currentValue].trim() : formData[currentValue];
          }
        }

        return accumulator;
      },
      {} as UserRegistrationData
    );

    this.dialogRef.close(mutationData);
  }
}
